module.exports = __webpack_public_path__ + "static/media/finland.e2b74ccd.svg";